import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {compose} from 'recompose';

import {setWrappedDisplayName} from '@webex/react-component-utils';

export const REMOVE_WIDGET = 'widget-base/REMOVE_WIDGET';
export function removeWidget() {
  return {
    type: REMOVE_WIDGET
  };
}

export default compose(
  setWrappedDisplayName('WithRemoveWidget'),
  connect(
    (state) => state,
    (dispatch) => bindActionCreators({
      removeWidget
    }, dispatch)
  )
);
